import { createApp } from 'vue';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import globalComponents from '@/components';
import router from './router';
import store from './store';
import i18n from './locale';
import directive from './directive';
import './mock';
import App from './App.vue';
import { installSingletonErrorMessage } from '@/utils/install-singleton-error-message';
// Styles are imported via arco-plugin. See config/plugin/arcoStyleImport.ts in the directory for details
// 样式通过 arco-plugin 插件导入。详见目录文件 config/plugin/arcoStyleImport.ts
// https://arco.design/docs/designlab/use-theme-package
import '@/assets/style/global.less';
import '@/api/interceptor';

function shouldReloadForAsyncChunkError(reason: unknown) {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : '';

  return /Loading chunk \d+ failed|ChunkLoadError|CSS_CHUNK_LOAD_FAILED|Failed to fetch dynamically imported module|Importing a module script failed/i.test(
    message
  );
}

function hardReloadOnce() {
  const key = 'app:chunk-load-reload-at';
  const last = Number(sessionStorage.getItem(key) ?? 0);
  const now = Date.now();
  if (now - last < 10_000) return;
  sessionStorage.setItem(key, String(now));

  const url = new URL(window.location.href);
  url.searchParams.set('__reload', String(now));
  window.location.replace(url.toString());
}

window.addEventListener('unhandledrejection', (event) => {
  if (shouldReloadForAsyncChunkError(event.reason)) {
    hardReloadOnce();
  }
});

const app = createApp(App);

app.use(ArcoVue, {});
installSingletonErrorMessage(app);

app.use(ArcoVueIcon);

app.use(router);
app.use(store);
app.use(i18n);
app.use(globalComponents);
app.use(directive);

app.mount('#app');
